export const SCREEN_RANGES = ["Sub 2 ore", "2–4 ore", "4–6 ore", "6–8 ore", "Peste 8 ore", "Nu știu"];

// Fiecare opțiune: t = text, w = pondere intensitate (max 3), p = profil asociat (0 Pilot, 1 Refugiu, 2 Amânare) sau null.
// Răspunsurile D au w = 0 și p = null: indică mai mult control, reduc intensitatea și nu sunt forțate într-un profil.
export const QUESTIONS = [
  {
    q: "În ce situație ajungi cel mai des să iei telefonul?",
    options: [
      { t: "Când am câteva secunde libere", w: 3, p: 0 },
      { t: "Când sunt stresat(ă) sau obosit(ă)", w: 3, p: 1 },
      { t: "Când am ceva de făcut și îl amân", w: 3, p: 2 },
      { t: "Când am un motiv clar", w: 0, p: null },
    ],
  },
  {
    q: "Cât de des intri pe telefon fără să-ți propui?",
    options: [
      { t: "Foarte des", w: 3, p: null },
      { t: "Des", w: 2, p: null },
      { t: "Uneori", w: 1, p: null },
      { t: "Rar", w: 0, p: null },
    ],
  },
  {
    q: "Ce faci când apare o notificare?",
    options: [
      { t: "O deschid imediat", w: 3, p: 0 },
      { t: "O verific mai ales când sunt tensionat(ă)", w: 3, p: 1 },
      { t: "O folosesc ca pauză de la ce făceam", w: 3, p: 2 },
      { t: "O las pentru mai târziu", w: 0, p: null },
    ],
  },
  {
    q: "Înainte să începi să dai scroll, ce simți cel mai des?",
    options: [
      { t: "Nimic special, e automat", w: 3, p: 0 },
      { t: "Vreau să mă relaxez", w: 3, p: 1 },
      { t: "Nu am chef să încep ce am de făcut", w: 3, p: 2 },
      { t: "Știu exact de ce deschid telefonul", w: 0, p: null },
    ],
  },
  {
    q: "Cât de des verifici telefonul fără notificări?",
    options: [
      { t: "Foarte des", w: 3, p: null },
      { t: "Des", w: 2, p: null },
      { t: "Uneori", w: 1, p: null },
      { t: "Rar", w: 0, p: null },
    ],
  },
  {
    q: "Ce ajunge să-ți afecteze cel mai des scroll-ul?",
    options: [
      { t: "Concentrarea", w: 3, p: null },
      { t: "Somnul sau relaxarea", w: 3, p: null },
      { t: "Lucrurile pe care trebuie să le fac", w: 3, p: null },
      { t: "Aproape nimic important", w: 0, p: null },
    ],
  },
  {
    q: "După ce ai stat mai mult pe telefon, ce observi?",
    options: [
      { t: "Nu-mi dau seama când a trecut timpul", w: 3, p: 0 },
      { t: "Nu mă simt cu adevărat odihnit(ă)", w: 3, p: 1 },
      { t: "Îmi dau seama că am amânat ceva", w: 3, p: 2 },
      { t: "L-am folosit exact cât aveam nevoie", w: 0, p: null },
    ],
  },
  {
    q: "Ce ai vrea să schimbi cel mai mult?",
    options: [
      { t: "Să nu mai deschid telefonul automat", w: 3, p: 0 },
      { t: "Să mă relaxez fără să ajung mereu la scroll", w: 3, p: 1 },
      { t: "Să încep mai ușor lucrurile importante", w: 3, p: 2 },
      { t: "Să păstrez controlul pe care îl am", w: 0, p: null },
    ],
  },
];

export const INTENSITY_LABELS = ["REDUSĂ", "MODERATĂ", "RIDICATĂ"];

export const PROFILES = [
  {
    key: "A",
    name: "PILOT AUTOMAT",
    headline: "Telefonul a devenit un reflex.",
    explanation:
      "Răspunsurile tale arată că îl deschizi adesea fără un motiv clar: în pauze, la notificări sau pur și simplu din obișnuință.",
    signal: "L-am deschis fără să-mi dau seama.",
    lever: "Creează puțină distanță între impuls și telefon.",
    action:
      "Scoate aplicația pe care intri cel mai des de pe primul ecran și întreabă-te înainte să o deschizi: «De ce intru acum?»",
  },
  {
    key: "B",
    name: "REFUGIU",
    headline: "Telefonul a devenit o pauză rapidă.",
    explanation:
      "Răspunsurile tale arată că ajungi la scroll mai ales când ești stresat(ă), obosit(ă) sau vrei să te detașezi.",
    signal: "Vreau doar să mă relaxez puțin.",
    lever: "Înlocuiește uneori scroll-ul cu o pauză care chiar te reface.",
    action:
      "Înainte de primul scroll neintenționat de azi, fă două minute de pauză fără telefon: apă, mers, întindere sau câteva respirații.",
  },
  {
    key: "C",
    name: "AMÂNARE",
    headline: "Telefonul a devenit o ieșire din lucrurile greu de început.",
    explanation:
      "Răspunsurile tale arată că scroll-ul apare des când ai ceva important de făcut și nu ai chef să începi.",
    signal: "Știu ce am de făcut, dar mai stau puțin.",
    lever: "Micșorează primul pas.",
    action:
      "Alege un lucru pe care îl amâni. Pune telefonul deoparte și lucrează doar două minute.",
  },
];

// Rezultat determinist: scor de intensitate + tipar dominant (cu tipar secundar la diferențe mici).
export function computeResult(answers) {
  let score = 0;
  const counts = [0, 0, 0];
  QUESTIONS.forEach((q, i) => {
    const a = answers[i];
    if (a === null || a === undefined) return;
    const opt = q.options[a];
    score += opt.w;
    if (opt.p !== null && opt.p !== undefined) counts[opt.p] += 1;
  });
  const intensity = score >= 16 ? "RIDICATĂ" : score >= 8 ? "MODERATĂ" : "REDUSĂ";
  const total = counts[0] + counts[1] + counts[2];
  const order = [0, 1, 2].sort((a, b) => counts[b] - counts[a] || a - b);
  const primary = order[0];
  const secondary = total > 0 && counts[order[0]] - counts[order[1]] <= 1 ? order[1] : null;
  return { score, intensity, counts, total, primary, secondary };
}
